import { render } from "./WCEditExpiredModal.vue?vue&type=template&id=6d2c3c18"
import script from "./WCEditExpiredModal.vue?vue&type=script&lang=js"
export * from "./WCEditExpiredModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__